// 2P AI — semaforo verticale a tre luci + parola di stato (§6). Verde=online, giallo=degradato,
// rosso=offline. Registro più tenue delle pastiglie sessione (è stato-macchina, non stato-sessione).
export type SemaforoState = 'green' | 'amber' | 'red';

const WORD: Record<SemaforoState, string> = { green: 'Online', amber: 'Degradato', red: 'Offline' };

export function ServerSemaforo({ state, word }: { state: SemaforoState; word?: string }) {
  return (
    <div className={`srvstat s-${state}`}>
      <span className="word">{word ?? WORD[state]}</span>
      <span className="semaforo" aria-hidden="true"><i className="r" /><i className="a" /><i className="g" /></span>
    </div>
  );
}
